import React from "react";
import {BrandName} from "../../../constants";
import {ListItem, Paragraph, Title} from "../TermsText";

const ParticipationEligibilitySection = () => {
  return (
    <>
      <Title>{"5. CONDITIONS OF PARTICIPATION."}</Title>

      <Paragraph>
        {"By entering a Challenge, entrants agree to be bound by these Rules and the decisions of "}{BrandName}{", which shall be final and binding in all respects. The Company, at its sole discretion, may disqualify any entrant from a Challenge, refuse to award benefits or prizes and require the return of any prizes, if the entrant engages in conduct or otherwise utilizes any information the Company deems to be improper, unfair or otherwise adverse to the operation of the Challenge or is in any way detrimental to other entrants. These Terms prohibit entering a Challenge if the entrant is:"}
      </Paragraph>

      <ListItem variant="primary">
        {"Except as otherwise stated in the Eligibility section above, an Employee of the Company or an immediate family member of such employee;"}
      </ListItem>

      <ListItem variant="primary">
        {"An employee or operator of any real money games site including any that charges entrance fees or offers prizes, and any Immediate Family Member of any such person;"}
      </ListItem>

      <ListItem variant="primary">
        {"Accessing or has had access to any pre-release, confidential information or other information that is not available to all other entrants of a Challenge and that provides the entrant an advantage in such a Challenge, including any information from any real money games site or information from a sports governing body (e.g., pre-release injury information) (\"Pre-Release Data\");"}
      </ListItem>

      <ListItem variant="primary">
        {"An employee of a sponsor, consultant, or supplier of the Company or any other real money games challenge provider that has access to Pre-Release Data or otherwise receives an advantage in the entrant's participation in a Challenge;"}
      </ListItem>

      <ListItem variant="primary">
        {"An employee, operator or consultant to a sports governing body where such employee, operator or consultant is prohibited from participating in applicable Challenges by such governing body;"}
      </ListItem>

      <ListItem variant="primary">
        {"Breaches any rules or policies of the entrant's employer, of any sports governing body, or any other professional body of which the entrant is a member, including any rule or policy regarding participation in Challenges or accepting prize money;"}
      </ListItem>

      <ListItem variant="primary">{"Any person prohibited from participating pursuant to court order;"}</ListItem>

      <ListItem variant="primary" mb={15}>
        {"Any entrant who has knowingly received Pre-Release Data or any other non-public information that provides an advantage in a Challenge from any person who is prohibited from entering a Challenge as provided in these Terms."}
      </ListItem>
    </>
  );
};

export default React.memo(ParticipationEligibilitySection);
